export const uxDesignerTeamWorkflow = {
  junior: {
    processes: [
      'Daily design standups',
      'Weekly design critiques',
      'Bi-weekly sprint planning',
      'Monthly design reviews',
      'Quarterly goal setting'
    ],
    responsibilities: [
      'Complete assigned design tasks',
      'Participate in critiques',
      'Document design decisions',
      'Follow design system guidelines',
      'Seek feedback regularly'
    ],
    ceremonies: [
      'Design standup (daily)',
      'Design critique (weekly)',
      'Sprint planning (bi-weekly)',
      'Retrospectives (monthly)'
    ]
  },
  mid: {
    processes: [
      'Lead design critiques',
      'Cross-functional collaboration',
      'User research planning',
      'Design system contributions',
      'Stakeholder presentations'
    ],
    responsibilities: [
      'Mentor junior designers',
      'Lead design projects',
      'Coordinate with product/engineering',
      'Contribute to design system',
      'Present to stakeholders'
    ],
    ceremonies: [
      'Design critique leadership',
      'Cross-team sync meetings',
      'User research sessions',
      'Design system reviews'
    ]
  },
  senior: {
    processes: [
      'Design strategy planning',
      'Team process optimization',
      'Cross-functional leadership',
      'Design system governance',
      'Executive reporting'
    ],
    responsibilities: [
      'Set design direction',
      'Manage design team',
      'Strategic planning',
      'Process improvement',
      'Executive communication'
    ],
    ceremonies: [
      'Strategic planning sessions',
      'Executive design reviews',
      'Team leadership meetings',
      'Process improvement workshops'
    ]
  }
};
